function compareFunctionConstructor(columnKey: string, isSortedDescending?: boolean) {
  function comparingFunction<T>(first: T, second: T) {
    const key = columnKey as keyof T;
    // don't sort if elements are the same
    if (first[key] === second[key]) {
      return 0;
    }

    // nulls sort after anything else if descending
    if (first[key] === null) {
      if (isSortedDescending) {
        return 1;
      } else {
        return -1;
      }
    } else if (second[key] === null) {
      if (isSortedDescending) {
        return -1;
      } else {
        return 1;
      }
    }
    const a = (first[key] as any).toUpperCase();
    const b = (second[key] as any).toUpperCase();
    // otherwise, if we're ascending, lowest sorts first
    if (isSortedDescending) {
      return a < b ? 1 : -1;
    }
    // if descending, highest sorts first
    else {
      return a < b ? -1 : 1;
    }
  }
  return comparingFunction;
}

export function copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
  const sortedItems = items.slice(0).sort(compareFunctionConstructor(columnKey, isSortedDescending));
  return sortedItems;
}
